<div class="wrapper">
  <img [ngSrc]="imageSrc" class="icon" width="304" height="270" alt="error">
  <p class="title" *ngIf="title">{{ title | translate }}</p>
  <p class="text" *ngIf="text">{{ text | translate }}</p>
</div>
